import {useState, useCallback} from "react";
import {Button } from "semantic-ui-react";
import {useDropzone} from "react-dropzone";
import {toast} from "react-toastify";
import {useMutation} from "@apollo/client/react";
import {UPDATE_AVATAR, GET_USER, DELETE_AVATAR} from "../../../gql/user";
import ImageNotFound from "../../../assets/png/avatar.png";
import "./AvatarForm.scss";
export default function AvatarForm(props) {
    const {setShowModal, auth} = props;
    const [loading, setLoading] = useState(false);

    const [updateAvatar] = useMutation(UPDATE_AVATAR, {
        update(cache, { data: { updateAvatar } }) {
            updateAvatarInCache(
            cache,
            `${updateAvatar.urlAvatar}?v=${Date.now()}`
            );
        },
    });
    /*
    const [updateAvatar] = useMutation(UPDATE_AVATAR, {
        update(cache, { data: {updateAvatar} }) {
            const {getUser} = cache.readQuery({
                query: GET_USER,
                variables: {username: auth.username},
            });
            cache.writeQuery({
                query: GET_USER,
                variables: {username: auth.username},
                data: {
                    getUser: {...getUser, avatar: `${updateAvatar.urlAvatar}?v=${Date.now()}`},
                },
            });
        },   
    });*/
    const [deleteAvatar] = useMutation(DELETE_AVATAR, {
        update(cache) { updateAvatarInCache(cache, ""); },
    });
    /*
    const [deleteAvatar] = useMutation(DELETE_AVATAR, {
        update(cache, { data: {deleteAvatar} }) {
            const {getUser} = cache.readQuery({
                query: GET_USER,
                variables: {username: auth.username},
            });
            cache.writeQuery({
                query: GET_USER,
                variables: {username: auth.username},
                data: {
                    getUser: {...getUser, avatar: ""},
                },
            });
        },   
    });*/
    const updateAvatarInCache = (cache, avatar) => {
        cache.modify({
            id: cache.identify({
                __typename: "User",
                id: auth.id,
            }),
            fields: {
                avatar() {
                    return avatar;
                },
            }
        });
    };

    const onDrop = useCallback(async (acceptedFiles) => {
        const file = acceptedFiles[0];
        try {
            setLoading(true);
            const result = await updateAvatar({variables: {file}});
            const {data} = result;
            if(!data.updateAvatar.status) {
                toast.error("Error al actualizar el avatar");
                setLoading(false);
            } else{
                setLoading(false);
                setShowModal(false);
            }
            console.log(result);
        } catch (error) {   
             console.log("ERROR COMPLETO", error);
        }
     }, []);
    const {getRootProps, getInputProps} = useDropzone({
        accept: "image/jpeg, image/png",
        noKeyboard: true,
        multiple: false,
        onDrop
    }); 
    const onDeleteAvatar = async () => {
        try{
            const result = await deleteAvatar();
            const {data} = result;
            console.log("RESULTADO DELETE AVATAR", data);
            if(!data) {
                toast.error("Error al eliminar el avatar");
            } else {
                setShowModal(false);
            }
        } catch (error) {
            console.log("ERROR COMPLETO", error);
        }
    };

    return (
        <div className="avatar-form">
            <Button {...getRootProps()} loading={loading}>
                Cargar una foto
            </Button>
            <Button onClick={onDeleteAvatar}>Eliminar foto actual</Button>
            <Button onClick={() => setShowModal(false)}>Cancelar</Button>
            <input {...getInputProps()} />
        </div>
    );
}